<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    isPrimaryButtonHidden="true" (closeButtonActionEmt)="closeModal()" secondaryButtonLabel="Close"
    [modalHelpIndex]="modalHelpIndex" [resizeHorizontal]="true" [resizeHorizontalMin]="605" [resizeVertical]="true"
    [resizeVerticalMin]="500">
    <div class="grid-container">
        <res-generic-grid gridName="{{containerTitle}}" [automationId]="modalAutomationId" [(isBusy)]="isBusy"
            [(isBusyMessage)]="isBusyMessage" [gridContext]="gridContext" [responseCallback]="responseCallback"
            [columnDefs]="columnDefs" [requestInfo]="requestInfo" [responseArrayCallback]="responseArrayCallback"
            [headerTemplate]="headerTemplate" [rowSelection]="rowSelection" [isRefreshIconHidden]="true"
            [pagerTemplate]="hasDownloadPermission ? pagerTemplate : null">
        </res-generic-grid>
    </div>
    <ng-template #headerTemplate>
        <div class='parent-header'>
            <span>{{containerTitle}}</span>
            <div class="button-group">
                <button type="button" data-automation-id="add-passwords" class="secondary-button"
                    (click)="openAddPasswordModal()">
                    <i class="fa fa-plus"></i>Add Passwords ...
                </button>
                <button type="button" data-automation-id="import-passwords" class="secondary-button"
                    *ngIf="modalData.modalType === 'KNOWN_PASSWORDS'" (click)="importPasswords()">
                    <i class="fa fa-share fa-rotate-90"></i>Import Found Passwords ...
                </button>
            </div>
            <div class='grid-row-delete'>
                <span class="selected-items">Selected:
                    <span>{{selectedItems()}}</span></span>
                <span (click)="deleteSelectedPasswords()"
                    [ngClass]="[numberOfSelectedPasswords > 0 ? 'enabled-class' : 'disabled-class']"
                    data-automation-id="delete-selected-button">
                    <i class="fa fa-trash sizing-icons"></i>Delete Selected</span>
            </div>
        </div>
    </ng-template>
    <ng-template #pagerTemplate>
        <button class="download-button" (click)="downloadPasswordList()"
            [attr.data-automation-id]="automationId + '-download-report-button'"
            [attr.title]="'Download Filtered Grid ...'">
            <i class="fa fa-download"></i>
        </button>
    </ng-template>
    <a download #downloadLink hidden target="_blank"></a>
</res-base-modal>